<script lang="ts">
interface Props {
    hideBlock?: boolean;
}

let { hideBlock = false }: Props = $props();
</script>

{#if !hideBlock}
    <hr class="service-divider" />
{/if}

<style lang="scss">
    .service-divider {
        background: var(--colour-noghrei-silver);
        border: 0;
        height: 0.1rem;
        margin: 0;
        width: 100%;
    }
</style>
